import { render, staticRenderFns } from "./Julia.vue?vue&type=template&id=291bcdb6&scoped=true"
import script from "./Julia.vue?vue&type=script&lang=ts"
export * from "./Julia.vue?vue&type=script&lang=ts"
import style0 from "./Julia.vue?vue&type=style&index=0&id=291bcdb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291bcdb6",
  null
  
)

export default component.exports